import { User } from 'apprise-core/user';
import { useLogged } from 'apprise-frontend-iam/login/logged';
import { useUserClone } from 'apprise-frontend-iam/user/context';
import { useRouting } from 'apprise-ui/utils/routing';
import { useNewUser } from './model';

export const userRoute = "/user"
export const accountParam = "drawer-account"




export const useUserRouting = () => {

    const clone = useUserClone()

    const newUserIn = useNewUser()

    const logged = useLogged()

    const routing = useRouting()

    const self = {

        listRoute: () => userRoute

        ,

        detailRoute: (id: string) => `${userRoute}/${id}`

        ,

        innerDetailRoute: (id: string) => `${userRoute}/${id}${routing.query()}`

        ,

        newDetailRoute: () => `${userRoute}/new`

        ,


        routeToList: () => routing.routeTo(self.listRoute())

        ,

        routeToDetail: (id: string) => routing.routeTo(self.detailRoute(id))

        ,

        routeToNewDetail: (model?: User) =>  {

            model ? clone.setQuietly(s => s.clone = model) : clone.resetQuietly()

            routing.routeTo(self.newDetailRoute())

        }

        ,

        nextUser: () => clone.get().clone ?? newUserIn(logged.tenant)

    }

    return self
}